import axios from "axios";
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API } from "@/lib/api";

const KEY = "empro_shop_token";
export const shopApi = axios.create({ baseURL: API });
shopApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Wystąpił błąd";
}

const Ctx = createContext(null);
export const useShopAuth = () => useContext(Ctx);

export function ShopAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const run = async () => {
      const hash = window.location.hash || "";
      if (hash.includes("session_id=")) {
        const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
        try {
          const { data } = await shopApi.post("/shop/auth/google", { session_id: sid });
          localStorage.setItem(KEY, data.token); setCustomer(data.customer);
          window.history.replaceState(null, "", window.location.pathname);
        } catch { /* ignore */ }
        setReady(true); return;
      }
      if (localStorage.getItem(KEY)) {
        try { const { data } = await shopApi.get("/shop/auth/me"); setCustomer(data); }
        catch { localStorage.removeItem(KEY); }
      }
      setReady(true);
    };
    run();
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await shopApi.post("/shop/auth/login", { email, password });
    localStorage.setItem(KEY, data.token); setCustomer(data.customer); return data.customer;
  }, []);
  const applyToken = useCallback((token, cust) => { localStorage.setItem(KEY, token); setCustomer(cust); }, []);
  const register = useCallback((email, password, name) => shopApi.post("/shop/auth/register", { email, password, name }), []);
  const googleLogin = useCallback(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/sklep/konto";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }, []);
  const logout = useCallback(() => { localStorage.removeItem(KEY); setCustomer(null); }, []);
  const refresh = useCallback(async () => { try { const { data } = await shopApi.get("/shop/auth/me"); setCustomer(data); } catch { /* ignore */ } }, []);

  return <Ctx.Provider value={{ customer, ready, login, register, googleLogin, logout, applyToken, refresh, setCustomer }}>{children}</Ctx.Provider>;
}
